import { motion } from "framer-motion";
import { useIsMobile, reveal } from "@/lib/motion";
import { PHI, TYPE, GLOW, glassReveal } from "@/lib/glass";
import { smarten } from "@/lib/typography";

const BODY = [
  "PrismPixel\u2122 is a medium of light. But a medium is only a means. Every dollar this invention earns is drawn back toward one purpose — to build an engine that does not run on charity, but on design.",
  "That engine is The Global Kindness Virus: a self-sustaining ecosystem built to reduce, at scale, the two darknesses I know most intimately — child abuse and domestic violence. Not reactive pity offered after the harm is done, but proactive prevention aimed at the roots: poverty, instability, the quiet economic pressures that turn a home into a battleground.",
  "The architecture is deliberate. Profit from the light is mission-locked, so it can never outgrow its conscience. It is reinvested into prevention that has been proven, not merely promised — financed by the invention's own patents rather than sold to the highest bidder, and scaled so that every measured reduction in violence becomes the asset that funds the next. Kindness, made perpetual. Good, made to compound.",
  "I have lived with my eyes wide open. I know the difference between beauty and its counterfeit, between light and the darkness it was pulled from. This is my answer to both: brilliant design set against deception, a well-worn life turned toward mercy.",
];

const bodyStyle = {
  marginBottom: PHI.s3,
  fontSize: TYPE.body,
  lineHeight: 1.85,
  letterSpacing: "0.02em",
  textShadow: GLOW.silverSoft,
};

// The financial engine — what the light is for. Placed beneath the audio.
export default function TheEngine() {
  const mobile = useIsMobile();

  return (
    <section
      data-testid="the-engine-section"
      style={{ paddingLeft: PHI.s3, paddingRight: PHI.s3, paddingTop: PHI.s5, paddingBottom: PHI.s6 }}
    >
      <div className="mx-auto max-w-[47rem]">
        <div aria-hidden="true" className="gold-hairline" style={{ marginBottom: PHI.s5 }} />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          {...glassReveal(reveal(mobile, { duration: 1.1 }))}
        >
          <p
            style={{ marginBottom: PHI.s3, fontSize: TYPE.lead, letterSpacing: "0.1em" }}
            className="font-display font-normal text-[#84DFF4]"
          >
            The Engine
          </p>
          <h2
            data-testid="the-engine-title"
            style={{ marginBottom: PHI.s4, fontSize: TYPE.h2, letterSpacing: "0.015em", lineHeight: 1.15, textShadow: GLOW.silver }}
            className="font-display font-light text-[#F5F5F7]"
          >
            The light is only the beginning.
          </h2>
          {BODY.map((t, i) => (
            <p key={i} style={bodyStyle} className="measure font-light text-[#F5F5F7]">
              {smarten(t)}
            </p>
          ))}
          <p
            data-testid="the-engine-mission"
            style={{ marginTop: PHI.s3, marginBottom: PHI.s3, fontSize: TYPE.lead, lineHeight: 1.6, letterSpacing: "0.035em", textShadow: GLOW.gold }}
            className="measure font-light italic text-[#84DFF4]"
          >
            {smarten(
              "To turn measurable good — the verifiable reduction of violence — into a perpetual, global mechanism for change."
            )}
          </p>
          <p style={bodyStyle} className="measure font-light text-[#F5F5F7]">
            That is what the light is for.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
